"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventLib = void 0;
require("./polyfills.ts");
var EventApp_1 = __importDefault(require("@/core/EventApp"));
var ExposedGlobalReceiver_1 = __importDefault(require("@/receiver/ExposedGlobalReceiver"));
var EventDispatcher_1 = __importDefault(require("@/dispatcher/EventDispatcher"));
var GoogleAnalyticsSender_1 = __importDefault(require("@/sender/google/GoogleAnalyticsSender"));
var ConversionHandler_1 = require("./handler/ConversionHandler");
var GoogleAnalyticsZero_1 = __importDefault(require("@/handler/form/GoogleAnalyticsZero"));
var GoogleAnalyticsZero_2 = __importDefault(require("@/handler/metric/GoogleAnalyticsZero"));
var googleHandler_1 = __importDefault(require("@/handler/form/googleHandler"));
var googleHandler_2 = __importDefault(require("@/handler/metric/googleHandler"));
var kafkaHandler_1 = __importDefault(require("@/handler/form/kafkaHandler"));
var googleHandler_3 = __importDefault(require("@/handler/calc/googleHandler"));
var GoogleAnalyticsZero_3 = __importDefault(require("@/handler/calc/GoogleAnalyticsZero"));
var constants_1 = require("./constants");
var KafkaSender_1 = __importDefault(require("@/sender/kafka/KafkaSender"));
var axios_1 = __importDefault(require("axios"));
var loglevel_1 = __importDefault(require("loglevel"));
var KafkaZero_1 = __importDefault(require("@/handler/form/KafkaZero"));
var eventLib = function (appConfig, isProd, exposedVar) {
    var eventlib = appConfig.eventlib;
    // Create logger instance
    var logger = loglevel_1.default.getLogger('eventlib');
    logger.setLevel(isProd ? 'error' : 'info');
    // Create default event receiver
    var receiver = new ExposedGlobalReceiver_1.default(logger);
    // Expose receiver as a global var
    Object.defineProperty(window, exposedVar, { value: receiver });
    // Prepare axios instance for kafka
    var kafkaClient = axios_1.default.create({ withCredentials: false, timeout: 10000 });
    // Create sender instances
    var googleSender = new GoogleAnalyticsSender_1.default(window.dataLayer, window._mtm, logger);
    var kafkaSender = new KafkaSender_1.default({
        bundleSendTimeout: 1000,
        retries: 8,
        bundleSize: 100,
        bufferSize: 1000,
        eventAggregateDelay: 5000
    }, kafkaClient, eventlib.formsApi, logger);
    // Create converters
    var formToGoogleConverter = new ConversionHandler_1.ConversionHandler(GoogleAnalyticsZero_1.default, logger, googleHandler_1.default);
    var formToKafkaConverter = new ConversionHandler_1.ConversionHandler(KafkaZero_1.default, logger, kafkaHandler_1.default);
    var metricToGoogleConverter = new ConversionHandler_1.ConversionHandler(GoogleAnalyticsZero_2.default, logger, googleHandler_2.default);
    var calcToGoogleConverter = new ConversionHandler_1.ConversionHandler(GoogleAnalyticsZero_3.default, logger, googleHandler_3.default);
    // Create dispatcher and register dispatch pipelines
    var dispatcher = new EventDispatcher_1.default(logger);
    // Set up handlers
    dispatcher.registerHandler([constants_1.Origin.Form, constants_1.Destination.GoogleAnalytics], formToGoogleConverter, googleSender);
    dispatcher.registerHandler([constants_1.Origin.Form, constants_1.Destination.Kafka], formToKafkaConverter, kafkaSender);
    dispatcher.registerHandler([constants_1.Origin.Metric, constants_1.Destination.GoogleAnalytics], metricToGoogleConverter, googleSender);
    dispatcher.registerHandler([constants_1.Origin.Calc, constants_1.Destination.GoogleAnalytics], calcToGoogleConverter, googleSender);
    // Create app config
    var config = {
        receiver: receiver,
        dispatcher: dispatcher,
        logger: logger
    };
    // Create app instance
    new EventApp_1.default(config);
};
exports.eventLib = eventLib;
exports.default = exports.eventLib;
